import notice from "../../../utils/notice";
import {
  getMultipartParams,
  handleResponse,
} from "../../../crud/helpers/validate";
import { FOCUS_URL } from "../../../crud/helpers/routes";
import { useContentsContext } from "./useContentsContext.hook";

export const useFocusAreas = () => {
  const { setAllFocusAreas } = useContentsContext();
  const getFocusAreas = async (slug = "", page = 1, query = "") => {
    try {
      const res = await fetch(
        `${FOCUS_URL}?page=${page}&search_query=${query}`,
        getMultipartParams("GET")
      );
      const json = await handleResponse(res);
      setAllFocusAreas(json);
    } catch (e) {
      notice("Error on loading focus areas");
      console.error(e.errors);
    }
  };

  return { getFocusAreas };
};
